import React, { Suspense, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
// import Footer from "../Shared/Footer/Footer";
import Navigation from "../Shared/Navigation/Index";
import { SignalRProvider } from "../Utils/SignalRContext";
// import { Box } from "@mui/material";
import SidebarChat from "../Shared/SidebarChat";
// import Header_logo_1 from '../images/Header_logo_1.png';
// import { RxCross2 } from "react-icons/rx";
import "../index.scss"
import SidebarMenu from './../Shared/SidebarMenu/index';
import AcademicYearProvider from "../context/AcademicYearProvider";
import { CircularProgress } from "@mui/material";

const Header_logo_1 = '/assets/FIG Agent.png'

function PrivateRoute() {
  const loggedIn = useSelector(
    (state) => state.login?.LoginDetails?.accessToken
  );
  let TopMenuList = useSelector((state) => state.setting?.TopMenuList);
  let { pathname } = useLocation();
  let psNameMessage = pathname?.split("/")[1] === "messages"

  const [isSidebarChatOpen, setIsSidebarChatOpen] = React.useState(); // Chat sidebar collapsed by default
  const handleLogoClick = () => {
    setIsOpen(false)
    setIsSidebarChatOpen(isSidebarChatOpen ? false : true);
  };
  const [isOpen, setIsOpen] = useState(false);
  if (!loggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <div
        className="chatLogoBtn"
        onClick={handleLogoClick}
      >
        <img
          className="img-fluid"
          src={Header_logo_1}
          alt="FIG K12 Logo"
        />
      </div>
      <div className="mainLayout">
        <div
          className={`wrapper ${isSidebarChatOpen ? "open" : "close"}`}
        >
          {TopMenuList?.filter(
            (x) => x.menuUrl?.split("/")[1] === pathname?.split("/")[1]
          )?.length > 0 ? (
            <>
              <SignalRProvider>
                <AcademicYearProvider>
                  <Navigation setIsSidebarChatOpen={setIsSidebarChatOpen} setIsOpen={setIsOpen} isOpen={isOpen} />
                  <div className="mainLayout">
                    <SidebarMenu setIsSidebarChatOpen={setIsSidebarChatOpen} setIsOpen={setIsOpen} isOpen={isOpen} />
                    <div className={`content ${isOpen ? "expanded" : "collapsed"}`}>
                      <Suspense
                        fallback={
                          <div className="loader">
                            <CircularProgress sx={{ color: "#86c65a" }} />
                          </div>
                        }
                      >

                        <Outlet />
                      </Suspense>
                    </div>
                  </div>
                </AcademicYearProvider>
              </SignalRProvider>
            </>
          ) : TopMenuList?.length > 0 ? (
            <Navigate to={TopMenuList[0]?.menuUrl} />
          ) : (
            <Navigate to="/" />
          )}
        </div >
        <SidebarChat isOpen={isSidebarChatOpen} psNameMessage={psNameMessage} onClose={() => setIsSidebarChatOpen(false)} />
      </div >
      {/* <Footer /> */}
    </>
  );
}

export default PrivateRoute;
